export default __webpack_public_path__ + "static/media/2116.877a4c0c.png";